import * as React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import "./index.css";
import App from "./App";
import axios from "axios";
import Cookies from "js-cookie";
import { ThemeProvider } from "./context/ThemeContext";
import { resolveApiBaseUrl } from "./helper/apiHost";
import { UNAUTH_ADMIN_REDIRECT, isAdminLoginPath } from "./helper/authPaths";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

axios.defaults.baseURL = resolveApiBaseUrl();

// Enable sending cookies with requests
axios.defaults.withCredentials = true;

// Global app API key (required by backend for all /api requests)
if (process.env.REACT_APP_API_KEY) {
  axios.defaults.headers.common['x-api-key'] = process.env.REACT_APP_API_KEY;
}

// Note: Token is stored in httpOnly cookie, so we don't need to manually add it to headers
// The backend will extract it from the cookie automatically
// We only add Authorization header as fallback if cookie is not available (for compatibility)
axios.interceptors.request.use(
  (config) => {
    if (process.env.REACT_APP_API_KEY) {
      config.headers['x-api-key'] = process.env.REACT_APP_API_KEY;
    }

    // Try to get token from cookie (if not httpOnly, for backward compatibility)
    const token = Cookies.get('token');

    // If token exists and not httpOnly, add it to Authorization header as fallback
    // This is optional since backend can read from cookie
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors (token expired/invalid)
let isRedirecting = false; // Prevent multiple redirects

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      const currentPath = window.location.pathname;
      const requestUrl = error.config?.url || '';

      // Don't redirect if:
      // 1. Already on the hidden login page
      // 2. Already redirecting
      // 3. The request is to /api/auth/verify (let the component handle it)
      // 4. The request is to /api/auth/login (login endpoint)
      // 5. The request is to public endpoints (verify, pdf)
      if (!isRedirecting &&
        !isAdminLoginPath(currentPath) &&
        !requestUrl.includes('/api/auth/verify') &&
        !requestUrl.includes('/api/auth/login') &&
        !requestUrl.includes('/api/loa/verify/') &&
        !requestUrl.includes('/api/loa/pdf/')) {
        
        isRedirecting = true;
        
        // Try to clear expired token cookie by calling clear-token endpoint
        try {
          await axios.post('api/auth/clear-token', {}, {
            withCredentials: true
          });
        } catch (clearError) {
          // Ignore errors when clearing token
        }
        
        // Session invalid: selalu ke beranda — jangan otomatis buka /management
        window.location.href = UNAUTH_ADMIN_REDIRECT;
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <CookiesProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CookiesProvider>
    </ThemeProvider>
  </React.StrictMode>
);
// serviceWorkerRegistration.register();
